import { useAPIV2 } from "../yoello-lib/modules/API2/useAPIv2";
import APIExtensions from "../yoello-lib/modules/API2/APIDefs";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { IReduxAppState } from "../reducers";
import IVenueSettings from "../interfaces/IVenueSettings";
import {
  generateTradingTimesObject,
  isVenueOpen,
} from "../yoello-lib/modules/utils/tradingTimesObject";

/**Hook which returns if a venue is open or closed */
export function useIsVenueOpen() {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const selectedVenueId = useSelector(
    (state: IReduxAppState) => state.selectedVenueId
  );
  const { apiData: tradingTimesData } = useAPIV2(APIExtensions.tradingTimes, {
    doNotCacheValue: true,
    yoelloAPIParams: { venue_id: selectedVenueId },
  });
  const { apiData } = useAPIV2<IVenueSettings>(APIExtensions.venueSettings, {
    yoelloAPIParams: { venue_id: selectedVenueId },
    selectorKeyParams: { venue_id: selectedVenueId },
  });
  useEffect(() => {
    if (tradingTimesData && apiData) {
      setIsLoading(true);
      const tradingTimesObject = generateTradingTimesObject(
        tradingTimesData as any
      );
      if (apiData.enabled === true && isVenueOpen(tradingTimesObject)) {
        setIsOpen(true);
      } else {
        setIsOpen(false);
      }
      setIsLoading(false);
    }
  }, [apiData, tradingTimesData]);

  return { isOpen, isLoading };
}